import WhatsAppIcon from "src/components/common/whats-app-icon";
import LayoutComponent from "src/components/user/layout-component";
import SchoolProfileList from "src/containers/admin/school-profile-list-container";
import SchoolInfoHeaderComponent from "src/components/user/school-info-header-component";

function SchoolProfilePage() {
  return (
    <LayoutComponent showLogo={true}>
      <div className="w-full h-full px-16 mobile:px-1.5 items-center justify-center bg-zinc-50">
        <div className="flex flex-col w-full pt-20">
          <WhatsAppIcon />
          <div className="flex flex-col items-center justify-center">
            <SchoolInfoHeaderComponent />
          </div>
          <div className="">
            <SchoolProfileList />
          </div>
        </div>
      </div>
    </LayoutComponent>
  );
}

export default SchoolProfilePage;
